<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="contact" />

		<article class="gb-legal">
			<hh1>Contact GB Apps</hh1>
			<p>We welcome feedback, suggestions, and questions from our visitors.</p>
			<p>
				If you have any questions about our content, notice an incorrect detail, or want to share suggestions
				for improving the website, feel free to contact us.
			</p>
			<p>You can contact us for:</p>
			<ul>
				<li>Content corrections</li>
				<li>Website feedback</li>
				<li>Copyright-related requests</li>
				<li>General inquiries</li>
				<li>Suggestions for new guides</li>
			</ul>
			<p>We aim to review messages and respond as soon as possible.</p>
			<p>
				<strong>Email:</strong>
				<a class="jump-url" href="mailto:contact@gbappss.co">contact@gbappss.co</a>
			</p>
			<p>
				<a class="jump-url" href="https://gbappss.co/">https://gbappss.co/</a>
			</p>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'Contact',
	components: { HeadNav },
}
</script>
